// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"2505":"164f4fb6","3632":"b645e135","7337":"ad2866b8","8445":"bc98253f"}[chunkId] || chunkId) + "." + {"907":"695ca6e730e55a51","2505":"9a39c0c91b28c167","3632":"402396b006a92c5f","7337":"914590e4e1652c3f","8445":"c5f2f3fc94bbd6a1","8985":"99ca4dd5cc07eb3a","9112":"141fa8b11cfe2ee2"}[chunkId] + ".js";
};